import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

interface LicenceUseProps {
    users: number;
    totalUsers?: number;
    onlyActives?: boolean;
}

const LicenceUse: React.SFC<LicenceUseProps> = ({ users, totalUsers, onlyActives }: LicenceUseProps) => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    return (
        <p className="licence-use">
            {`${strings.HOME_ORGANIZATION_HAS} `}
            <span>
                <span>{users}</span>
                {totalUsers && ` / ${totalUsers}`}
            </span>
            {onlyActives ? ` ${strings.HOME_ACTIVE_USERS}` : ` ${strings.HOME_REGISTERED_USERS}`}
        </p>
    );
};

export default LicenceUse;
